'use client'

import React, { PropsWithChildren, ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { ScrollArea } from '@/components/ui/scroll-area'
import { FilterSidebar } from '@/components/assets-explorer/filters/filter-sidebar'
import { useParams } from 'next/navigation'
import { useAppStore } from '@/lib/store/store'

export default function Layout({
  children,
  categoriesNav,
}: PropsWithChildren<{
  categoriesNav: ReactNode
}>) {
  const { category, subCategory } = useParams<{
    mainCategory: string
    category?: string
    subCategory?: string
  }>()

  const showFilterSidebar = !!category && !!subCategory

  // Wait for the store to hydrate before rendering
  const hasHydrated = useAppStore((state) => state._hasHydrated)
  if (!hasHydrated) {
    return null
  }

  return (
    <div
      className={cn('main-category-layout', 'tw-grid tw-h-full tw-grid-rows-[auto_1fr]', {
        'tw-grid-cols-[auto_1fr]': showFilterSidebar,
        'tw-grid-cols-[1fr]': !showFilterSidebar,
      })}
    >
      {showFilterSidebar && (
        <div className="tw-row-span-2">
          <div className="tw-sticky tw-top-[var(--header-height)] tw-p-2 tw-pr-0">
            <ScrollArea className="tw-h-[calc(100dvh-var(--header-height)-1rem)] tw-rounded tw-bg-[var(--Primary)]">
              <FilterSidebar />
            </ScrollArea>
          </div>
        </div>
      )}

      <div
        className={cn(
          'tw-sticky tw-left-0 tw-top-[var(--header-height)] tw-z-[2] tw-mb-4 tw-min-w-14 tw-bg-[rgb(var(--background-start-rgb))]',
          {
            'tw-px-2': !showFilterSidebar,
          }
        )}
      >
        {categoriesNav}
      </div>

      <div className="main-category-layout-content">{children}</div>
    </div>
  )
}
